

export const GRAPH_API_BASE_URL = 'https://graph.microsoft.com/v1.0';

const OFFICE_ADDIN_BASE_URL = "/SI.Biz.Core.OfficeAddin/SI.Biz.Core.OfficeAddin/";
const OFFICE_ADDIN_OUTLOOK_SERVICE = "OutlookService/";
const OFFICE_ADDIN_OFFICE_SERVICE = "OfficeService/";
const OFFICE_ADDIN_DATA_SERVICE = "DataService/";
const CACHE_SETTINGS = "/SI.Biz.Core/SI.Biz.Core.Surface/SettingsCache/";
const SUPPORT = "/Biz/v2/support/";

enum API_NAMES {
    PING = "Ping",
    GET_ARCHIVE = "GetArchivedMailInfo",
    GET_MULTIPLE_ARCHIVE = "GetMultipleArchivedMailInfo",
    SAVE_MAIL_USING_WIZARD = "SaveMailUsingNewOutlook",
    SAVE_MULTIPLE_EMAILS = "SaveMultipleEmails",
    SAVE_MAIL = "SaveMail",
    GET_PROD_NAME = "GetProductName",
    GETCONFIG = "GetConfigurations",
    UPLOAD = "uploadfile",
    SAVEFILE_FROM_OFFICE = "SaveFileFromOffice",
    GET_ARCHIVE_FILE = "GetArchivedFileInfo",
    GET_FILEDETAILS_FROM_DOCUMENT = "GetDetailFromDocument",
    CHECKIN_STREAM = "checkinfile",
    UNDOCHECKOUT = "UndoCheckout",
    GET_INSERTABLE_ARCHIVES = "GetInsertableArchives",
    GET_EMAIL_DOCUMENT_CATEGORIES = "GetEmailDocumentCategories",
    SEARCH_CASE_PREPOPULATE = "SearchCasePrepopulate",
    SEARCH_CASE_FOR_NEW_DOCUMENT = "SearchCaseForNewDocument",
    GET_RECORD_TYPES = "GetRecordTypes",
    CARBON_COPY_CONTACT_PREPOPULATE = "SearchCarbonCopyPrepopulate",
    SEARCH_CARBON_COPY_CONTACTS = "SearchCarbonCopyContacts",
    VALIDATE_CASE = "ValidateArchiveAndCaseForNewDocument",
    GET_ACCESS_CODES = "GetAccessCodesForDocumentArchive",
    GET_PARAGRAPHS = "GetParagraphsForAccessCode",
    GET_ACCESS_GROUPS = "GetAccessGroupsForDocumentArchive",
    IS_FEATURE_ON = "IsFeatureOn",
    GET_VALUE = "GetValues",
    DELETE_TEMPORARY_IMPORT_ARCHIVE_DOCUMENTS = "DeleteTemporaryImportArchiveDocuments"
}

export class ApiConfig {

    public static readonly getConfig: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OUTLOOK_SERVICE + API_NAMES.GETCONFIG;
    public static readonly checkConnection: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OUTLOOK_SERVICE + API_NAMES.PING;
    public static readonly GetArchivedMailInfo: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OUTLOOK_SERVICE + API_NAMES.GET_ARCHIVE;
    public static readonly GetMultipleArchivedMailInfo: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OUTLOOK_SERVICE + API_NAMES.GET_MULTIPLE_ARCHIVE;
    public static readonly SaveMailUsingWizard: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OUTLOOK_SERVICE + API_NAMES.SAVE_MAIL_USING_WIZARD;
    public static readonly SaveMultipleEmails: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OUTLOOK_SERVICE + API_NAMES.SAVE_MULTIPLE_EMAILS;
    public static readonly DeleteTemporaryImportArchiveDocuments: string =
        OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OUTLOOK_SERVICE + API_NAMES.DELETE_TEMPORARY_IMPORT_ARCHIVE_DOCUMENTS;
    public static readonly getProductName: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OFFICE_SERVICE + API_NAMES.GET_PROD_NAME;
    public static readonly upload = SUPPORT + API_NAMES.UPLOAD;
    public static readonly SaveFileFromOffice = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OFFICE_SERVICE + API_NAMES.SAVEFILE_FROM_OFFICE;
    public static readonly GetDetailFromDocument: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OFFICE_SERVICE + API_NAMES.GET_FILEDETAILS_FROM_DOCUMENT;
    public static readonly GetArchivedFileInfo: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OFFICE_SERVICE + API_NAMES.GET_ARCHIVE_FILE;
    public static readonly UndoCheckout: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OFFICE_SERVICE + API_NAMES.UNDOCHECKOUT;
    public static readonly checkinStream: string = SUPPORT + API_NAMES.CHECKIN_STREAM;
    public static readonly UndoCheckoutSVC: string = SUPPORT + "undocheckoutfile";

    public static readonly GetInsertableArchives: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.GET_INSERTABLE_ARCHIVES;
    public static readonly GetEmailDocumentCategories: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.GET_EMAIL_DOCUMENT_CATEGORIES;
    public static readonly SearchCasePrepopulate: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.SEARCH_CASE_PREPOPULATE;
    public static readonly SearchCaseForNewDocument: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.SEARCH_CASE_FOR_NEW_DOCUMENT;
    public static readonly GetRecordTypes: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.GET_RECORD_TYPES;
    public static readonly CarbonCopyContactPrepopulate: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.CARBON_COPY_CONTACT_PREPOPULATE;
    public static readonly SearchCarbonCopyContacts: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.SEARCH_CARBON_COPY_CONTACTS;
    public static readonly ValidateCase: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.VALIDATE_CASE;
    public static readonly SaveMail: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_OUTLOOK_SERVICE + API_NAMES.SAVE_MAIL;
    public static readonly GetAccessCodes: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.GET_ACCESS_CODES;
    public static readonly GetParagraphsForAccessCode: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.GET_PARAGRAPHS;
    public static readonly GetAccessGroups: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.GET_ACCESS_GROUPS;
    public static readonly IsFeatureOn: string = OFFICE_ADDIN_BASE_URL + OFFICE_ADDIN_DATA_SERVICE + API_NAMES.IS_FEATURE_ON;
    public static readonly GetValueFromSettings: string = CACHE_SETTINGS + API_NAMES.GET_VALUE;
}

export const getFetchApiOptions = (): RequestInit => {
    return {
        mode: "cors" as RequestMode,
        credentials: "include" as RequestCredentials,
        redirect: "error" as RequestRedirect
    };

};

export const getEnvironment360BizURL = () => {
    return getEnvironment360URL() + "/Biz/v2/api/call";
};

export const getEnvironment360URL = () => {
    let public360Url = localStorage.getItem("public360Url");

    if (public360Url === "")
        public360Url = new URLSearchParams(window.location.search).get("url");

    return public360Url ?? "";
};
